// extracted by mini-css-extract-plugin
export default {"dropdown":"SearchContainer_dropdown__2ocMg","no_result":"SearchContainer_no_result__xDs2A"};